module.exports = __webpack_public_path__ + "static/media/onboarding-auto-access.en.34d58647.png";